import { isNotNullNorUndefined } from '@silo/utils';
import mean from 'lodash/mean';
import { getAPYTrend } from '../apy/apy-trend';
import { ApyChartData } from './ApyChart';

export const calculateTrends = (data: ApyChartData) => {
  return {
    deposit: data.every((d) => isNotNullNorUndefined(d.depositApy))
      ? calculateTrend(data.map((d) => d.depositApy!).reverse())
      : undefined,
    borrow: data.every((d) => isNotNullNorUndefined(d.depositApy))
      ? calculateTrend(data.map((d) => d.borrowApy!).reverse())
      : undefined,
  };
};

const calculateTrend = (values: number[]) => {
  const trend = getAPYTrend(values);
  if (trend.direction !== 'none') {
    const trendingValues = values.slice(0, trend.count + 1);
    const diffs = trendingValues.slice(1).map((x, i) => trendingValues[i] - x);

    return {
      direction: trend.direction,
      value: mean(diffs),
      average: mean(values),
    };
  }

  return trend;
};
